export default __webpack_public_path__ + "static/media/help_outline_black_24dp@2x.95417232.png";